import { useTranslation } from "react-i18next";
import logoDark from "@/assets/anthmai-logo-dark.svg";
import logoLight from "@/assets/anthmai-logo-light.svg";

/** Full AnthmAI lockup; swaps variants with the design system's `.dark` class. */
export function Logo({ className = "h-6" }: Readonly<{ className?: string }>) {
  const { t } = useTranslation();
  return (
    <>
      <img src={logoDark} alt={t("appName")} className={`block w-auto dark:hidden ${className}`} />
      <img src={logoLight} alt={t("appName")} className={`hidden w-auto dark:block ${className}`} />
    </>
  );
}
